import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { BallotListService } from '../ballot-list/ballot-list.service';
import { BallotService } from '../ballot/ballot.service';
import { declinedRoute } from '../route-names';
import { DeclarationService } from './declaration.service';

@Component({
    selector: 'app-decline-modal',
    templateUrl: './decline-modal.component.html',
    styleUrls: ['./decline-modal.component.scss'],
    standalone: false
})
export class DeclineModalComponent {

  readonly isBallotError = new BehaviorSubject<boolean>(false);
  readonly error = new BehaviorSubject<string>("");
  displayProgressSpinner: boolean = false
  
  constructor(
    private readonly declarationService: DeclarationService,
    private readonly ballotService: BallotService,
    private readonly ballotListService: BallotListService,
    private readonly router: Router,
    public dialogRef: MatDialogRef<DeclineModalComponent>,
  ) {}


  submit() {
    const ballot = this.ballotService.getBallot()
    if (ballot) {
      this.displayProgressSpinner = true
      const declinedBallot = this.declarationService.generateDeclinedBallot(ballot)
      this.ballotService.submit(declinedBallot).subscribe({
        next: (anonID) => {
          this.ballotListService.voted(ballot)
          this.router.navigate(declinedRoute, {state: {confirmationId: anonID, confirmationType: ballot?.voteEventData.optionalEventConfiguration?.confirmationDeliveryChannel, ballotType: ballot.eventType }})
        },
        error: (err) => {
          this.displayProgressSpinner = false;
          this.isBallotError.next(true);
          this.error.next(err.error.error_type);
        },
        complete: () => {
          this.displayProgressSpinner = false
          this.dialogRef.close()
        }
      });
    }
  }

}
